import { createSlice, isAnyOf } from "@reduxjs/toolkit";
import {
  getAllJobTimeChecksAsync,
  getJobTimeCheckByIdAsync,
  createJobTimeCheckAsync,
  correctJobTimeCheckImageAsync,
} from "./jobTimeCheck.async";

const initialState = {
  jobTimeCheckListLoader: false,
  jobTimeCheckList: {},

  jobTimeCheckByIdLoader: false,
  jobTimeCheckById: {},

  jobTimeCheckCreateLoader: false,
  jobTimeCheckCreateInfo: {},

  jobTimeCheckCorrectLoader: false,
  jobTimeCheckCorrectInfo: {},
};

export const jobTimeCheckSlice = createSlice({
  name: "jobTimeCheck",
  initialState,
  reducers: {
    emptyJobTimeCheckCreateInfo: (state) => {
      state.jobTimeCheckCreateInfo = {};
    },
  },
  extraReducers: (builder) => {
    // List
    builder.addMatcher(
      isAnyOf(getAllJobTimeChecksAsync.pending),
      (state) => {
        state.jobTimeCheckListLoader = true;
      }
    );
    builder.addMatcher(
      isAnyOf(getAllJobTimeChecksAsync.fulfilled),
      (state, action) => {
        state.jobTimeCheckListLoader = false;
        state.jobTimeCheckList = action.payload?.data || {};
      }
    );
    builder.addMatcher(
      isAnyOf(getAllJobTimeChecksAsync.rejected),
      (state) => {
        state.jobTimeCheckListLoader = false;
      }
    );

    // Get by id (View Images)
    builder.addMatcher(
      isAnyOf(getJobTimeCheckByIdAsync.pending),
      (state) => {
        state.jobTimeCheckByIdLoader = true;
        state.jobTimeCheckById = {};
      }
    );
    builder.addMatcher(
      isAnyOf(getJobTimeCheckByIdAsync.fulfilled),
      (state, action) => {
        state.jobTimeCheckByIdLoader = false;
        state.jobTimeCheckById = action.payload?.data || {};
      }
    );
    builder.addMatcher(
      isAnyOf(getJobTimeCheckByIdAsync.rejected),
      (state) => {
        state.jobTimeCheckByIdLoader = false;
      }
    );

    // Create / add image
    builder.addMatcher(
      isAnyOf(createJobTimeCheckAsync.pending),
      (state) => {
        state.jobTimeCheckCreateLoader = true;
      }
    );
    builder.addMatcher(
      isAnyOf(createJobTimeCheckAsync.fulfilled),
      (state, action) => {
        state.jobTimeCheckCreateLoader = false;
        state.jobTimeCheckCreateInfo = action.payload;
      }
    );
    builder.addMatcher(
      isAnyOf(createJobTimeCheckAsync.rejected),
      (state) => {
        state.jobTimeCheckCreateLoader = false;
      }
    );

    // Correct one image
    builder.addMatcher(
      isAnyOf(correctJobTimeCheckImageAsync.pending),
      (state) => {
        state.jobTimeCheckCorrectLoader = true;
      }
    );
    builder.addMatcher(
      isAnyOf(correctJobTimeCheckImageAsync.fulfilled),
      (state, action) => {
        state.jobTimeCheckCorrectLoader = false;
        state.jobTimeCheckCorrectInfo = action.payload;
        state.jobTimeCheckById = action.payload?.data || state.jobTimeCheckById;
      }
    );
    builder.addMatcher(
      isAnyOf(correctJobTimeCheckImageAsync.rejected),
      (state) => {
        state.jobTimeCheckCorrectLoader = false;
      }
    );
  },
});

export const { emptyJobTimeCheckCreateInfo } = jobTimeCheckSlice.actions;

export default jobTimeCheckSlice.reducer;
